import React from 'react'
import './LeftSidebar.css'
import { NavLink } from 'react-router-dom'
import Globe from  '../../assets/Globe.svg'
import { Link } from 'react-router-dom'


const LeftSidebar = () => {
   
    return (
        
        <div className='left-sidebar'>
            <nav className='side-nav'>
            
                <NavLink to='/' className='side-nav-links' activeclassname='active'>
                    <p>Home</p>
                </NavLink>
                <div className='side-nav-div'>
                    <div><p>PUBLIC</p></div>
                    <NavLink to='/Questions' className='side-nav-links' activeclassname='active'>
                        <img src={Globe} alt="Globe" />
                        <p style={{paddingLeft: "10px"}}> Questions </p>
                    </NavLink>
                    <NavLink to='/Tags' className='side-nav-links' activeclassname='active' style={{paddingLeft: "40px"}}>
                        <p>Tags</p>
                    </NavLink>
                    <NavLink to='/Users' className='side-nav-links' activeclassname='active' style={{paddingLeft: "40px"}}>
                        <p>Users</p>
                    </NavLink>
                    <NavLink to='/products' className='side-nav-links side-nav-list' activeclassname='active'>
                        <p style={{paddingLeft: "10px"}}> Products </p>
                    </NavLink>
                    <a href='https://stackoverflow.co/teams/' className='side-nav-links side-nav-list'   activeclassname='active'>
                        <p style={{paddingLeft: "10px"}}> For Teams </p>
                    </a>
                    <a href= "#" className='side-nav-links' activeclassname='active' style={{paddingLeft: "40px"}}>
                        <p> Community </p>
                    </a>
                
                </div>
            </nav>
        </div>
    )
}

export default LeftSidebar
